import React, { useEffect } from 'react'
import type { RemoteReceiver } from '@remote-ui/core'
import { RemoteRenderer } from '@remote-ui/react/host'
import { Controller } from '@remote-ui/react/build/ts/host'

export interface RemoteRendererProps {
	receiver: RemoteReceiver
	remoteRender: (props?: any) => void
	controller: Controller
	unMount?: () => void
}

export interface ExternalComponentProps {
	compProps?: any
}

const prepareExternalComponent = ({ receiver, remoteRender, controller, unMount }: RemoteRendererProps) => ({
	compProps,
}: ExternalComponentProps) => {
	useEffect(() => {
		remoteRender(compProps)
	}, [compProps])

	useEffect(() => {
		return () => {
			if (unMount) {
				unMount()
			}
		}
	}, [])

	return <RemoteRenderer receiver={receiver} controller={controller} />
}

export default prepareExternalComponent
